// src/admin/adminSozluk.js
//
// ADMIN EKRANLARININ DİL SÖZLÜĞÜ — TEK KAYNAK (2026-08-21)
//
// Katılımcı tarafı (App.js i18n, rapor motoru, rapor bileşeni, erişim hataları)
// baştan iki dilliydi; admin ekranları değildi. Bu dosya o boşluğu kapatır.
//
// İKİ AYRI "DİL" KARIŞTIRILMAMALI:
//   · arayüz dili  → adminin GÖRDÜĞÜ dil (bu sözlük)
//   · link dili    → LinklerSayfasi'ndaki "Link dili" seçicisi; katılımcının
//                    açacağı envanterin dili. Bambaşka bir şey.
// Ayrıca ClassAnalysis, bastığı raporu KAYDIN kendi diliyle üretir
// (record.lang) — admin arayüzü İngilizce olsa da Türkçe katılımcının raporu
// Türkçe basılır. Bu kasıtlıdır.

const SOZLUK = {
  tr: {
    // ── ClassAnalysis ──────────────────────────────────────────────
    baslik: "DISC Admin — Sınıf ve Kişi Analizi",
    yukleniyor: "Yükleniyor...",
    okunanKayit: "Okunan kayıt",
    filtrelenenKayit: "Filtrelenen kayıt",
    raporOzetiOlan: "Rapor özeti olan kayıt",
    listelenenKisi: "Listelenen kişi",
    baskinDagilim: "Baskın DISC Dağılımı",
    jenerasyonKirilimi: "Jenerasyon Kırılımı",
    rolKirilimi: "Rol Seviyesi Kırılımı",
    isimleriGoster: "İsimleri göster",
    ipucuAcik: " · noktanın üzerine gelince ad, harf ve yüzde görünür",
    ipucuKapali: " · grafik anonim; noktanın üzerine gelince yalnız harf ve yüzde görünür",
    uyarlanmisDagilim: "Uyarlanmış Profil Dağılımı",
    dogalDagilim: "Doğal Profil Dağılımı",
    kisiListesi: (n) => `Kişi Listesi — ${n} kayıt`,
    sayfa: "Sayfa",
    sayfaBilgi: (bas, son, top) => `${bas}–${son} / ${top}`,
    oncekiSayfa: "Önceki", sonrakiSayfa: "Sonraki",
    discDagilimi: "DISC Dağılımı",
    hata: "Hata",
    sutunTarih: "Tarih",
    sutunSure: "Süre",
    sutunJenerasyon: "Jenerasyon",
    sutunRol: "Rol",
    sutunKatilimci: "Katılımcı",
    sutunSirketTakim: "Şirket / Takım",
    sutunUyarli: "Uyarlı",
    sutunDogal: "Doğal",
    sutunBosluk: "Boşluk",
    sutunIslem: "İşlem",
    boslukIpucu: "En çok / en az tarafında hiçbir harfe puan yazmayan seçim sayısı",
    boslukOzeti: (t, m, l) => `Toplam ${t} grup · en çok ${m} boşluk, en az ${l} boşluk`,
    pdfIpucu: "Someren Labs antetli, baskıya hazır tam rapor",
    katilimciPdfIpucu: "Katılımcının envanter sonunda gördüğü kadarı: yalnız uyarlanmış ve doğal grafikler",
    secilenKisiRaporu: "Seçilen Kişi Raporu",
    son30: "Son 30 kayıt", son100: "Son 100 kayıt", son250: "Son 250 kayıt", tumKayitlar: "Tüm kayıtlar",
    tumu: "Tümü", son7Gun: "Son 7 gün", son30Gun: "Son 30 gün", son90Gun: "Son 90 gün",
    araPlaceholder: "Ad, takma ad, şirket, takım...",
    filtreler: "Filtreler",
    kapsam: "Kapsam",
    filtreSirket: "Şirket",
    filtreTarih: "Tarih",
    filtreJenerasyon: "Jenerasyon",
    filtreRolSeviyesi: "Rol seviyesi",
    filtreArama: "İsim / takma ad ara",
    raporuAc: "Raporu Aç",
    katilimciPdf: "Katılımcı PDF",
    pdfKaydet: "PDF olarak kaydet",
    kapat: "Kapat",
    discKarti: "↓ DISC Kartı (PDF)",
    discKartiIpucu: "Tek sayfalık kart: dört çeyrek, eksenler ve alıcıya göre iletişim.",
    raporDili: "Rapor dili",
    arayuzIleAyni: "Arayüz diliyle aynı",
    kaydinDili: "Kaydın kendi dili",
    // ── Jenerasyon / rol etiketleri ────────────────────────────────
    oncesi1964: "1964 ve öncesi",
    rolUst: "Üst Yönetim / C-Level / Genel Müdür",
    rolDirektor: "Direktör / Fonksiyon Lideri",
    rolMudur: "Müdür",
    rolTakimLideri: "Takım Lideri / Supervisor",
    rolUzman: "Uzman / Bireysel Katkı Sağlayan",
    rolOperasyon: "Operasyon / Saha Ekibi",
    rolOgrenci: "Öğrenci",
    rolDiger: "Diğer",
    belirtilmedi: "Belirtilmedi",
    // ── LinklerSayfasi ─────────────────────────────────────────────
    lnkBaslik: "Katılımcı Linkleri",
    lnkAltBaslik: "Bu sayfa Someren Labs temsilcisi içindir.",
    lnkSifre: "Şifre",
    lnkHataliSifre: "Hatalı şifre.",
    lnkYukleniyor: "Yükleniyor…",
    lnkKodlarOkunamadi: "Kodlar okunamadı. Bağlantını kontrol edip tekrar dene.",
    lnkLinkDili: "Link dili",
    lnkIpucuOnce: "Adı yaz, ",
    lnkIpucuSonra: "'a bas — ya da başka bir yere tıkla. Kendiliğinden kaydedilir.",
    lnkKodYok: "Bu seçimde DISC katılımcı kodu yok.",
    lnkSirket: "Şirket",
    lnkHarcanmaz: "açılmakla harcanmaz",
    lnkHarcanmazDevam: "; yalnız envanter tamamlanınca paketten 1 hak düşer.",
    lnkKopyalandi: "Kopyalandı",
    lnkKullanildi: "kullanıldı",
    lnkAcik: "açık",
    lnkAc: "Aç",
    lnkLinkler: "Linkler",
    lnkYenile: "Yenile",
    lnkTumu: (n) => `Tümü (${n} kod)`,
    lnkDilTr: "Türkçe",
    lnkDilEn: "İngilizce",
    lnkKimeVerildi: "Kime verildi",
    lnkKod: "Kod",
    lnkLink: "Link",
    lnkDurum: "Durum",
    lnkNot1: "Kişi linke tıklar, doğrudan envantere girer — kod yazmasına gerek yoktur.",
    lnkNot2Once: "Kod ",
    lnkNot3: "“Kime verildi” yazdığın anda kaydedilir; lisans kaydının ",
    lnkNot3Son: " alanında durur.",
    lnkKaydediliyor: "kaydediliyor…",
    lnkKaydedildi: "✓ kaydedildi",
    lnkKaydedilemedi: "✗ kaydedilemedi — tekrar dene",
    lnkKaydedilmedi: "kaydedilmedi · Enter'a bas",
    lnkArayuzDili: "Arayüz dili",
  },

  en: {
    // ── ClassAnalysis ──────────────────────────────────────────────
    baslik: "DISC Admin — Class and Individual Analysis",
    yukleniyor: "Loading…",
    okunanKayit: "Records read",
    filtrelenenKayit: "Records after filter",
    raporOzetiOlan: "Records with report summary",
    listelenenKisi: "People listed",
    baskinDagilim: "Dominant DISC Distribution",
    jenerasyonKirilimi: "Generation Breakdown",
    rolKirilimi: "Role Level Breakdown",
    isimleriGoster: "Show names",
    ipucuAcik: " · hover a dot to see the name, letter and percentage",
    ipucuKapali: " · chart is anonymous; hover a dot to see only the letter and percentage",
    uyarlanmisDagilim: "Adapted Profile Distribution",
    dogalDagilim: "Natural Profile Distribution",
    kisiListesi: (n) => `People — ${n} records`,
    sayfa: "Page",
    sayfaBilgi: (bas, son, top) => `${bas}–${son} of ${top}`,
    oncekiSayfa: "Previous", sonrakiSayfa: "Next",
    discDagilimi: "DISC Distribution",
    hata: "Error",
    sutunTarih: "Date",
    sutunSure: "Duration",
    sutunJenerasyon: "Generation",
    sutunRol: "Role",
    sutunKatilimci: "Participant",
    sutunSirketTakim: "Company / Team",
    sutunUyarli: "Adapted",
    sutunDogal: "Natural",
    sutunBosluk: "Blanks",
    sutunIslem: "Action",
    boslukIpucu: "Number of choices that score no letter on the most / least side",
    boslukOzeti: (t, m, l) => `${t} groups in total · ${m} blank on most, ${l} blank on least`,
    pdfIpucu: "Full report on Someren Labs letterhead, print-ready",
    katilimciPdfIpucu: "Only what the participant sees at the end of the inventory: adapted and natural charts",
    secilenKisiRaporu: "Selected Person's Report",
    son30: "Last 30 records", son100: "Last 100 records", son250: "Last 250 records", tumKayitlar: "All records",
    tumu: "All", son7Gun: "Last 7 days", son30Gun: "Last 30 days", son90Gun: "Last 90 days",
    araPlaceholder: "Name, nickname, company, team…",
    filtreler: "Filters",
    kapsam: "Scope",
    filtreSirket: "Company",
    filtreTarih: "Date",
    filtreJenerasyon: "Generation",
    filtreRolSeviyesi: "Role level",
    filtreArama: "Search name / nickname",
    raporuAc: "Open Report",
    katilimciPdf: "Participant PDF",
    pdfKaydet: "Save as PDF",
    kapat: "Close",
    discKarti: "↓ DISC Card (PDF)",
    discKartiIpucu: "One-page card: four quadrants, the axes, and how to shape the message.",
    raporDili: "Report language",
    arayuzIleAyni: "Same as interface",
    kaydinDili: "The record's own language",
    // ── Jenerasyon / rol etiketleri ────────────────────────────────
    oncesi1964: "1964 and earlier",
    rolUst: "Executive / C-Level / CEO",
    rolDirektor: "Director / Function Lead",
    rolMudur: "Manager",
    rolTakimLideri: "Team Lead / Supervisor",
    rolUzman: "Specialist / Individual Contributor",
    rolOperasyon: "Operations / Field Team",
    rolOgrenci: "Student",
    rolDiger: "Other",
    belirtilmedi: "Not specified",
    // ── LinklerSayfasi ─────────────────────────────────────────────
    lnkBaslik: "Participant Links",
    lnkAltBaslik: "This page is for the Someren Labs representative.",
    lnkSifre: "Password",
    lnkHataliSifre: "Wrong password.",
    lnkYukleniyor: "Loading…",
    lnkKodlarOkunamadi: "Codes could not be read. Check your connection and try again.",
    lnkLinkDili: "Link language",
    lnkIpucuOnce: "Type the name, press ",
    lnkIpucuSonra: " — or click elsewhere. It saves automatically.",
    lnkKodYok: "There is no DISC participant code in this selection.",
    lnkSirket: "Company",
    lnkHarcanmaz: "opening a link costs nothing",
    lnkHarcanmazDevam: "; one use is deducted from the package only when the inventory is completed.",
    lnkKopyalandi: "Copied",
    lnkKullanildi: "used",
    lnkAcik: "open",
    lnkAc: "Open",
    lnkLinkler: "Links",
    lnkYenile: "Refresh",
    lnkTumu: (n) => `All (${n} codes)`,
    lnkDilTr: "Turkish",
    lnkDilEn: "English",
    lnkKimeVerildi: "Assigned to",
    lnkKod: "Code",
    lnkLink: "Link",
    lnkDurum: "Status",
    lnkNot1: "The person clicks the link and goes straight into the inventory — no code to type.",
    lnkNot2Once: "A code ",
    lnkNot3: "It is saved the moment you type “Assigned to”; it lives in the licence record's ",
    lnkNot3Son: " field.",
    lnkKaydediliyor: "saving…",
    lnkKaydedildi: "✓ saved",
    lnkKaydedilemedi: "✗ could not save — try again",
    lnkKaydedilmedi: "not saved · press Enter",
    lnkArayuzDili: "Interface language",
  },
};

export function getAdminText(lang) {
  return SOZLUK[lang === "en" ? "en" : "tr"];
}

export default SOZLUK;
